import { createContext, Dispatch, SetStateAction } from "react"
import { UploadedFile } from "../../utility/common/files"

export interface DroppableAreaContextType {
    isDropped: boolean
    files: UploadedFile[] | File[]
    localFiles: File[]
    setFiles: Dispatch<SetStateAction<UploadedFile[] | File[]>>
}

export const droppableAreaContextDefaultValue: DroppableAreaContextType = {
    isDropped: false,
    files: [],
    localFiles: [],
    setFiles: prev => prev
}

const DroppableAreaContext = createContext<DroppableAreaContextType>(droppableAreaContextDefaultValue)

export default DroppableAreaContext
